const logs = {
    page_title: 'Audit logs',
    title: 'Audit logs',
    subtitle: 'Visualize os dados de log dos eventos de autenticação feitos por seu administrador e usuários',
    event: 'Evento',
    user: 'Usuário',
    application: 'Aplicativo',
    time: 'Tempo',
    filter_by: 'Filtrar por',
    last_1_hour: 'Última hora',
    last_24_hours: 'Últimas 24 horas',
    last_7_days: 'Últimos 7 dias',
    last_30_days: 'Últimos 30 dias',
    custom_range: 'Intervalo personalizado',
    from: 'De',
    to: 'Até',
};
export default Object.freeze(logs);
